import { render, staticRenderFns } from "./AdminMemberDemographics.vue?vue&type=template&id=1c2e7547&scoped=true&"
import script from "./AdminMemberDemographics.vue?vue&type=script&lang=js&"
export * from "./AdminMemberDemographics.vue?vue&type=script&lang=js&"
import style0 from "./AdminMemberDemographics.vue?vue&type=style&index=0&id=1c2e7547&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2e7547",
  null
  
)

export default component.exports